var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatechallengeCompvscomp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4583_1685)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6667 3.33333H25V6.66667H26.6667V38.3333H28.3333V13.3333L38.3333 18.3333V38.3333H40V40H0V38.3333H1.66667V20H13.3333V38.3333H15V6.66667H16.6667V3.33333H20V0H21.6667V3.33333ZM35 38.3333V35H31.6667V38.3333H35ZM10 38.3333V35H5V38.3333H10ZM23.3333 38.3333V35H18.3333V38.3333H23.3333ZM20 31.6667V10H18.3333V31.6667H20ZM35 31.6667V30H31.6667V31.6667H35ZM5 31.6667V28.3333H3.33333V31.6667H5ZM11.6667 31.6667V28.3333H10V31.6667H11.6667ZM8.33333 31.6667V28.3333H6.66667V31.6667H8.33333ZM23.3333 31.6667V10H21.6667V31.6667H23.3333ZM35 28.3333V26.6667H31.6667V28.3333H35ZM5 26.6667V23.3333H3.33333V26.6667H5ZM8.33333 26.6667V23.3333H6.66667V26.6667H8.33333ZM11.6667 26.6667V23.3333H10V26.6667H11.6667ZM35 25V23.3333H31.6667V25H35ZM35 21.435V19.7683H31.6667V21.435H35Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4583_1685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatechallengeCompvscomp);
export default __webpack_public_path__ + "static/media/createchallenge-compvscomp.a85f33ebc265954788b9e2dc60887308.svg";
export { ForwardRef as ReactComponent };